const hy = {
  welcome: `Բարի Գալուստ`,
  // TODO HY translation
  description: `UXCP-ն միակ հանրային գործիքն է, որը վերլուծում է մարդկանց մտածելակերպը՝ հիմնվելով նրանց կոգնիտիվ հակումների վրա։\n
  Դուք ստեղծում եք պրոֆիլներ («Պերսոնաներ»)՝ անվանելով դրանք և ընտրելով այն հակումները, որոնք բնորոշ են նրանց։ Այս պրոֆիլները կարող են ներկայացնել ինչպես առանձին անհատների, այնպես էլ խմբերի - կոնկրետ անձանցից մինչև ավելի լայն կատեգորիաներ, ինչպիսիք են «Կանացի լսարանը» կամ «Կանադացիները»։ Համակարգը վերլուծում է 105 տարբեր կոգնիտիվ հակումներ 63 բիզնես հարցերի շրջանակներում։`,
  descriptionLink: {
    info: 'Այս գործիքի ամբողջական նկարագրությունը կարող եք գտնել ',
    title: 'Medium-ում այս հղումով։',
    target: '_target',
    href: 'https://medium.com/@alexanyanwolf/creating-user-persona-with-cognitive-biases-and-ux-core-cb5a03a897a9',
  },
  exampleText: 'Persona examples',
  exampleMobileText: 'Persona examples',
  examples: [
    {
      title: 'Steve Jobs',
      link: 'https://google.com/search?q=Steve Jobs',
    },
    {
      title: 'Warren Buffett',
      link: 'https://google.com/search?q=Warren Buffett',
    },
    {
      title: 'Barak Obama',
      link: 'https://google.com/search?q=Barak Obama',
    },
    {
      title: 'Uber_user_Middle_East',
      link: 'https://google.com/search?q=Uber_user_Middle_East',
    },
    {
      title: 'iPhone_user_Somali',
      link: 'https://google.com/search?q=iPhone_user_Somali',
    },
    {
      title: 'Twitter_crypto_influencer',
      link: 'https://google.com/search?q=Twitter_crypto_influencer',
    },
    {
      title: 'Twitter_politician',
      link: 'https://google.com/search?q=Twitter_politician',
    },
  ],
  title: `Պերսոնայի կառուցում`,
  sectionTitle: `Ավելացրեք հակումներ Պերսոնային`,
  analyzeTeamMemeber: `Վերլուծե՞լ որպես թիմի անդամ`,
  analyzeTeamMemeberTooltip: `Երբ միացված է, համակարգը կընտրի ձեր նշածներից առավել համապատասխան հակումները Ձեր Պերսոնային։`,
  personaInputLabel: 'Պերսոնայի անուն',
  personaInputPlaceholder: 'Լևոն Յան',
  personaInputMobilePlaceholder: 'Պերսոնայի անուն',
  biasSearchPlaceholder: 'Որոնել',
  biasSearchTip: 'Մուտքագրիր հակումը կամ դրա նկարագրության մի մասը',
  addButtonText: 'Ավելացնել',
  showAllText: 'Ցույց տալ ամբողջը',
  yes: `Այո`,
  no: `Ոչ`,
  subSectionTitle: `Հատուկ ըմբռնումներ`,
  suggestedQuestionsTitle: `Առաջարկվող հարցեր ուսումնասիրելու համար`,
  suggestedQuestionsDescription: `Համակարգը գտել է մեկ կամ մի քանի հարցեր, որոնք կապված չեն ձեր ընտրած հակումների հետ, բայց շատ հաճախ հայտնվում են «Պերսոնա»-ի հետ կապված հարցերում: Մենք խորհուրդ ենք տալիս ձեր հետազոտության մեջ ուսումնասիրել նաև այս հարցերը:`,
  teamRelatedInsightsTitle: 'Թիմին վերաբերող հատուկ ըմբռնումներ',
  teamRelatedInsightsDescription1: `The option "Analyze as a team member" is enabled. In this section, you will see the biases that you have to focus on in the first place while considering your cooperation with `,
  teamRelatedInsightsDescription2: ` որպես թիմի անդամ.`,
  questionHighRelevancyText: `Պերսոնայի բարձր համապատասխանություն `,
  questionMediumRelevancyText: `Պերսոնայի միջին համապատասխանություն `,
  questionLowRelevancyText: `Պերսոնայի ցածր համապատասխանություն`,
  noData: `Չկան տվյալներ`,
  pieChartSectionTitle: `Պերսոնայի հարցեր ըստ պրոդուկտի փուլերի`,
  personaRelatedQuestionsTitle: `Պերսոնային վերաբերվող հարցեր`,
  relevancyLevel: `Համապատասխանության աստիճան`,
  relevancyLevelHint: `Համապատասխանությունը հաշվարկվում է ընտրված հակումներում գտնված նմանատիպ հարցերի քանակի հիման վրա։`,
  all: `Բոլորը`,
  highPriority: `Բարձր`,
  mediumPriority: `Միջին`,
  lowPriority: `Ցածր`,
  and: `ԵՎ`,
  other: `ուրիշ`,
  pageTitle: `Էջ`,
  questionLabel: `հարց`,
  appearsIn1: 'Հայտնվում է ',
  appearsInPersonaRelatedQuestions: '% Պերսոնային վերաբերվող հարցերում (',
  appearsInSelectedBiases: '%-ում ընտրած հակումներից (',
  appearsIn2: 'ից ',
  appearsIn3: ')',
  pieChartPlaceholder: 'Սկսելու համար ընտրեք պրոդուկտի փուլը',
  biasPlaceholder: 'Սկսելու համար ընտրեք հակում',
  copyURL: 'Պատճենել',
  copied: 'Պատճենված է!',
  mobileDisclimer: 'Պերսոնայի կառուցումը հասանելի է միայն համակարգչով',
  searchResultText1: 'գտնվել է',
  searchResultText2: 'արդյունք',
  stage: 'stage',
  biasPopupCustomTip:
    'Սեղմիր համարի վրա՝ UX Core-ում հակումը բացելու համար (in a new tab)',
};

export default hy;
